import Viewport from "../Viewport";
import ViewportComponent from '../../Component/Map/Viewport';
import Point from '../../Utility/Point';
import TransformComponent from '../../Component/Transform';
import Renderable from '../../Component/Renderable';
import Interactable from '../../Component/Interactable';
import { Layout } from 'Utility/layout/createLayout';
import { FarmLayout } from '../../Layouts/Farm/FarmLayout';
import PIXIRenderer from "System/Render/PIXIRenderer";

export default class FarmMap extends Viewport {
    private farmLayout: any;

    public getLayout(): Layout {
        return this.farmLayout;
    }

    public onCreate(params: {
        position: Point;
    }) {
        this.name = 'farm';
        this.farmLayout = new FarmLayout();
        this.addChild(this.farmLayout.root);

        this.addComponent(ViewportComponent, {
            drag: {
                direction: 'all',
            },
            decelerate: { friction: 0 },
            clamp: { direction: 'all' },
            ...params
        });

        this.addComponent(TransformComponent, params);
        this.addComponent(Renderable, params);
        this.addComponent(Interactable, params);

        this.handleResize();
    }

    public readonly handleResize = (): void => {
        if(this.farmLayout.root.destroyed) return;

        const transform = this.farmLayout.farmBg.getComponent(TransformComponent);
        const aspectRatio = transform.width / transform.height;


        if (PIXIRenderer.renderer.width / PIXIRenderer.renderer.height <= aspectRatio) {
            // Set height to match the renderer and set the width based on the aspect ratio.
            transform.height = PIXIRenderer.renderer.height;
            transform.width = transform.height * aspectRatio;
        } else {
            // Set width to match the renderer and set the height based on the aspect ratio.
            transform.width = PIXIRenderer.renderer.width;
            transform.height = transform.width / aspectRatio;
        }

        this.resize(PIXIRenderer.renderer.width, PIXIRenderer.renderer.height, transform.width, transform.height);
    }
}
